// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:font/woff2;charset=utf-8;base64,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 format%28%27woff2%27", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.\\!collapse {
  visibility: collapse !important;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.right-2 {
  right: 0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-14 {
  height: 3.5rem;
}
.min-h-screen {
  min-height: 100vh;
}
.w-full {
  width: 100%;
}
.max-w-4xl {
  max-width: 56rem;
}
.shrink {
  flex-shrink: 1;
}
.grow {
  flex-grow: 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize {
  resize: both;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-3 {
  gap: 0.75rem;
}
.self-end {
  align-self: flex-end;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-primeGray {
  --tw-border-opacity: 1;
  border-color: rgb(102 102 102 / 1);
  border-color: rgb(102 102 102 / var(--tw-border-opacity, 1));
}
.bg-primeBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(83 176 165 / 1);
  background-color: rgb(83 176 165 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.text-left {
  text-align: left;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-normal {
  font-weight: 400;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-feature-settings: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.text-primeBlue {
  --tw-text-opacity: 1;
  color: rgb(83 176 165 / 1);
  color: rgb(83 176 165 / var(--tw-text-opacity, 1));
}
.text-primeGray {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / 1);
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_50px_\\#666666\\] {
  --tw-shadow: 0 10px 50px #666666;
  --tw-shadow-colored: 0 10px 50px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  /* overflow-x: hidden; */
  width: 100vw;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.ag-cell[col-id='country'] {
  overflow: visible !important;
}

.multi-select-dropdown {
  background-color: #fff !important;
  border: 1px solid #53b0a5 !important;
}

.apply-button {
  border: 1px solid #53b0a5 !important;
  color: #53b0a5 !important
}

.npi-title {
  color: rgba(0, 144, 248, 1) !important;
}

.form-label {
  /* Add label styles here */
  font-size: 14px !important;
  color: #666 !important;
  font-family: Jost !important;
  margin: 10px
}

.form-control {
  /* Add control container styles here */
  font-size: 14px !important;
  color: #666 !important;
  font-family: Jost !important;
  margin: 10px
}

.form-control input[type="checkbox"],
.form-control input[type="radio"],
.form-control input[type="text"] {
  /* Add control styles here */
  font-size: 14px !important;
  color: #666 !important;
  font-family: Jost !important;
  margin: 10px
}

.form-field {
  /* Add field container styles here */
  font-size: 14px !important;
  color: #666 !important;
  font-family: Jost !important;
  margin: 10px
}

.submit-btn {
  /* Add submit button styles here */
  font-size: 14px !important;
  color: #666 !important;
  font-family: Jost !important;
  margin: 10px
}

li.MuiBreadcrumbs-separator.css-1wuw8dw-MuiBreadcrumbs-separator {
  margin-left: 0;
  margin-right: 0;
}

svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {
  color: "#FF7E07";
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* background-color: rgba(102, 102, 102, 0.2); */
  /* background-color: rgba(245, 242, 242, 0.808); */
  background-color: rgba(102, 102, 102, 0.3);
  opacity: 0.1;
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

/* 
   SURGICAL ICON RESTORATION: Negates duplicate icons and black/ghost squares.
   Target ONLY the deepest icon element to prevent side-by-side duplication.
*/
.ag-theme-alpine .ag-icon::before,
.ag-theme-manage-providers .ag-icon::before {
  font-family: "agGridAlpine" !important;
  background: transparent none !important; /* Removes ghost squares and gradients */
  background-color: transparent !important;
  color: inherit !important;
  display: inline-block !important;
  width: auto !important;
  height: auto !important;
  mask: none !important;
  -webkit-mask: none !important;
}

/* Explicitly restore missing icons using verified codes from node_modules */
.ag-theme-alpine .ag-icon-menu::before,
.ag-theme-alpine .ag-icon-menu-alt::before {
  content: '\\f138' !important; /* Mapped to three dots (menu-alt) specifically */
}

/* Pagination arrows restoration */
.ag-theme-alpine .ag-icon-next::before     { content: '\\f120' !important; }
.ag-theme-alpine .ag-icon-previous::before { content: '\\f126' !important; }
.ag-theme-alpine .ag-icon-first::before    { content: '\\f116' !important; }
.ag-theme-alpine .ag-icon-last::before     { content: '\\f119' !important; }

/* Filter and other core icons */
.ag-theme-alpine .ag-icon-filter::before { content: '\\f115' !important; }
.ag-theme-alpine .ag-icon-small-down::before { content: '\\f12b' !important; }
.ag-theme-alpine .ag-icon-tree-closed::before { content: '\\f130' !important; }
.ag-theme-alpine .ag-icon-tree-open::before { content: '\\f132' !important; }



/* Re-define the icon font globally using verified AG Grid v33 legacy font data */
@font-face {
  font-family: "agGridAlpine";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-primeBlue:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(83 176 165 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px) {

  .md\\:min-w-\\[840px\\] {
    min-width: 840px;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .md\\:border-r-0 {
    border-right-width: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,6IAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,uDAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B;AACF;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B;AACF;;AAEA;;;EAGE,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B;AACF;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B;AACF;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,kDAAkD;EAClD,0CAA0C;EAC1C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;;;CAGC;AACD;;EAEE,sCAAsC;EACtC,uCAAuC,EAAE,wCAAwC;EACjF,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,4EAA4E;AAC5E;;EAEE,2BAA2B,EAAE,iDAAiD;AAChF;;AAEA,kCAAkC;AAClC,6CAA6C,2BAA2B,EAAE;AAC1E,6CAA6C,2BAA2B,EAAE;AAC1E,6CAA6C,2BAA2B,EAAE;AAC1E,6CAA6C,2BAA2B,EAAE;;AAE1E,gCAAgC;AAChC,2CAA2C,2BAA2B,EAAE;AACxE,+CAA+C,2BAA2B,EAAE;AAC5E,gDAAgD,2BAA2B,EAAE;AAC7E,8CAA8C,2BAA2B,EAAE;;;;AAI3E,iFAAiF;AACjF;EACE,2BAA2B;EAC3B,4CAAopK;AACtpK;AAtJA;EAAA,8BAsJC;EAtJD;AAsJC;AAtJD;EAAA,2GAsJC;EAtJD,yGAsJC;EAtJD,0EAsJC;EAtJD;AAsJC;AAtJD;EAAA,oBAsJC;EAtJD;AAsJC;AAtJD;;EAAA;IAAA;EAsJC;;EAtJD;IAAA;EAsJC;;EAtJD;IAAA;EAsJC;;EAtJD;IAAA;EAsJC;;EAtJD;IAAA,oBAsJC;IAtJD;EAsJC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml,\nbody {\n  /* overflow-x: hidden; */\n  width: 100vw;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.ag-cell[col-id='country'] {\n  overflow: visible !important;\n}\n\n.multi-select-dropdown {\n  background-color: #fff !important;\n  border: 1px solid #53b0a5 !important;\n}\n\n.apply-button {\n  border: 1px solid #53b0a5 !important;\n  color: #53b0a5 !important\n}\n\n.npi-title {\n  color: rgba(0, 144, 248, 1) !important;\n}\n\n.form-label {\n  /* Add label styles here */\n  font-size: 14px !important;\n  color: #666 !important;\n  font-family: Jost !important;\n  margin: 10px\n}\n\n.form-control {\n  /* Add control container styles here */\n  font-size: 14px !important;\n  color: #666 !important;\n  font-family: Jost !important;\n  margin: 10px\n}\n\n.form-control input[type=\"checkbox\"],\n.form-control input[type=\"radio\"],\n.form-control input[type=\"text\"] {\n  /* Add control styles here */\n  font-size: 14px !important;\n  color: #666 !important;\n  font-family: Jost !important;\n  margin: 10px\n}\n\n.form-field {\n  /* Add field container styles here */\n  font-size: 14px !important;\n  color: #666 !important;\n  font-family: Jost !important;\n  margin: 10px\n}\n\n.submit-btn {\n  /* Add submit button styles here */\n  font-size: 14px !important;\n  color: #666 !important;\n  font-family: Jost !important;\n  margin: 10px\n}\n\nli.MuiBreadcrumbs-separator.css-1wuw8dw-MuiBreadcrumbs-separator {\n  margin-left: 0;\n  margin-right: 0;\n}\n\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {\n  color: \"#FF7E07\";\n}\n\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 8px;\n  height: 0px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  /* background-color: rgba(102, 102, 102, 0.2); */\n  /* background-color: rgba(245, 242, 242, 0.808); */\n  background-color: rgba(102, 102, 102, 0.3);\n  opacity: 0.1;\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n/* \n   SURGICAL ICON RESTORATION: Negates duplicate icons and black/ghost squares.\n   Target ONLY the deepest icon element to prevent side-by-side duplication.\n*/\n.ag-theme-alpine .ag-icon::before,\n.ag-theme-manage-providers .ag-icon::before {\n  font-family: \"agGridAlpine\" !important;\n  background: transparent none !important; /* Removes ghost squares and gradients */\n  background-color: transparent !important;\n  color: inherit !important;\n  display: inline-block !important;\n  width: auto !important;\n  height: auto !important;\n  mask: none !important;\n  -webkit-mask: none !important;\n}\n\n/* Explicitly restore missing icons using verified codes from node_modules */\n.ag-theme-alpine .ag-icon-menu::before,\n.ag-theme-alpine .ag-icon-menu-alt::before {\n  content: '\\f138' !important; /* Mapped to three dots (menu-alt) specifically */\n}\n\n/* Pagination arrows restoration */\n.ag-theme-alpine .ag-icon-next::before     { content: '\\f120' !important; }\n.ag-theme-alpine .ag-icon-previous::before { content: '\\f126' !important; }\n.ag-theme-alpine .ag-icon-first::before    { content: '\\f116' !important; }\n.ag-theme-alpine .ag-icon-last::before     { content: '\\f119' !important; }\n\n/* Filter and other core icons */\n.ag-theme-alpine .ag-icon-filter::before { content: '\\f115' !important; }\n.ag-theme-alpine .ag-icon-small-down::before { content: '\\f12b' !important; }\n.ag-theme-alpine .ag-icon-tree-closed::before { content: '\\f130' !important; }\n.ag-theme-alpine .ag-icon-tree-open::before { content: '\\f132' !important; }\n\n\n\n/* Re-define the icon font globally using verified AG Grid v33 legacy font data */\n@font-face {\n  font-family: \"agGridAlpine\";\n  src: url(data:font/woff2;charset=utf-8;base64,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 format('woff2');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
